import {Component, OnInit} from '@angular/core';
import {NavBaseComponent} from '../nav-base/nav-base.component';
import {AuthService} from "../../auth/auth.service";
import {TranslateService} from "../../shared/translate.service";
import {UserNotificationService} from "../../auth/notification/user-notification.service";

@Component({
  selector: 'app-nav-notification',
  templateUrl: './nav-notification.component.html',
  styleUrls: ['../nav-base/nav-base.component.scss', '../nav-extras/nav-extras.component.scss']
})
export class NavNotificationComponent extends NavBaseComponent implements OnInit {

  loggedIn = false;

  notificationCount: number = 0;

  constructor(public authService: AuthService,
              public translateService: TranslateService,
              private notificationService: UserNotificationService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.authService.isLogged.subscribe(value => {
      this.loggedIn = value;
    });

    this.updateNotificationsList();
  }

  showList: boolean = false;

  toggleShowList() {
    this.showList = !this.showList;
  }

  updateNotificationsList() {
    this.authService.isLogged.subscribe(value => {
      if(value) {
        this.authService.getToken().then(token => {
          this.notificationService.getUserNotifications(0,10, token).subscribe(value => {
            this.notificationCount = value.totalElements;
          });
        });
      }
    });
  }

  hideNotifications() {
    setTimeout(() => {
      this.showList = false;
      this.updateNotificationsList();
    }, 300);
  }

  decrementCount() {
    this.notificationCount = this.notificationCount - 1;
  }
}
